import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IDealerInformationVDF } from '../models/model'

export class AddDealerInformationListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/addDealerInformationListVDF',
      requesterInfo,
    })
  }

  public async addDealerInformationList(dealerInfo: IDealerInformationVDF[]): Promise<any> {
    return await this.postAsync<any>(dealerInfo)
  }
}
